import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { resetPassword } from '../../api/authentication';

const PasswordResetForm = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    setSubmitting(true);
    const res = await resetPassword({ token, password });
    if (res?.code === 200) setMessage('Password reset successful. Please log in.');
    else setMessage(res?.error || 'Something went wrong.');
    setSubmitting(false);
  };

  return (
    <Form onSubmit={submit} className="mt-3">
      <Form.Group className="mb-3">
        <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Control type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm password" />
      </Form.Group>
      {message && <p>{message}</p>}
      <Button type="submit" disabled={!password || !confirmPassword || submitting}>Reset password</Button>
    </Form>
  );
};

export default PasswordResetForm;
